
import { lookupPostcode, searchJobsByPostcode } from '@/api';
import DateRangeCustom from '@/components/searchPage/DateRangeCustom.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Button from '@/components/UI/button/Button.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { notificationErrorText, timeZoneDefault } from '@/utils/PortalConstants';
import { addDays } from 'date-fns';
import Input from '@/components/searchPage/Input.vue';
import JobTable from '@/components/dashBoard/jobTable/JobTable.vue';
import LookupPostcode from '@/components/searchPage/components/LookupPostcode/LookupPostcode.vue';
import { Header, IGetJobs, Job, LookupPostcodeData, User } from '@/models/main';

@Component({
  components: {
    Button,
    BackButton,
    DateRangeCustom,
    JobTable,
    Input,
    LookupPostcode,
  },
  computed: {
    ...mapState('moduleUser', { userSelectedDates: 'userSelectedDates' }),
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class SearchPostcode extends Vue {
  private user!: User;
  private loading = false;

  private autocompletePostcode = lookupPostcode;

  private datesIdSearch: string[] = [];
  private postcode = '';
  private distance = {
    20: true,
    50: false,
    100: false,
    200: false,
  };

  private jobs: Job[] = [];

  private postcodeLookupData = {
    id: -1,
    name: '',
    postcode: '',
    state: '',
    status: -1,
    zone: '',
  };

  private headers: Header[] = [
    { text: 'Id', value: 'id', align: 'left' },
    { text: 'Date', value: 'job_date', align: 'left' },
    { text: 'Customer Code', value: 'customer_code', align: 'left' },
    { text: 'Reference 1', value: 'ref1', align: 'left' },
    { text: 'Suburb Name', value: 'stop2_name', align: 'left' },
    { text: 'Suburb State', value: 'suburb_state2', align: 'left' },
    { text: 'Stop Number', value: 'main_stop', align: 'left' },
    { text: 'Driver', value: 'driver2', align: 'left' },
    { text: 'Service code', value: 'cost_service', align: 'left' },
    { text: 'Warehouse', value: 'wh_status', align: 'left', sortable: false },
    { text: 'Attributes', value: 'attributes', align: 'left', sortable: false },
    { text: 'Status', value: 'status', align: 'left', sortable: false },
  ];

  private postcodeLookupDataChanged(data) {
    this.postcodeLookupData = data;
  }

  private setDefaultDatesRange(): void {
    // Default is +7 days from today
    const userTimeZone = this.user.timezone || timeZoneDefault;
    const fromDate = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd'); // today
    const toDate = format(utcToZonedTime(addDays(new Date(), 14), userTimeZone), 'yyyy-MM-dd'); // + 14 days
    this.datesIdSearch = [fromDate, toDate];
  }

  private clearDatesIdSearch(): void {
    this.setDefaultDatesRange();
  }

  private changeDateIdSearch(dates: string[]) {
    this.datesIdSearch = dates;
  }

  private distanceClicked(value) {
    if (!this.loading) {
      Object.keys(this.distance).map(item => {
        this.distance[item] = false;
      });
      this.distance[value] = true;
    }
    if (this.postcodeLookupData.id !== -1) {
      this.find();
    }
  }

  private find() {
    this.loading = true;
    const distanceChosen = Object.values(this.distance).findIndex(x => !!x);
    const params: LookupPostcodeData = {
      dates: this.datesIdSearch,
      suburb_id: this.postcodeLookupData.id,
      postcode: this.postcodeLookupData.postcode,
      distance: Number(Object.keys(this.distance)[distanceChosen]),
    };
    searchJobsByPostcode(params)
      .then((data: IGetJobs) => {
        this.jobs = [...data.cancelled, ...data.completed, ...data.in_progress, ...data.unallocated];
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error getting the jobs',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private mounted() {
    this.setDefaultDatesRange();
  }
}
